import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=d6134144&scoped=true"
import script from "./DataSource.vue?vue&type=script&lang=js"
export * from "./DataSource.vue?vue&type=script&lang=js"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=d6134144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6134144",
  null
  
)

export default component.exports